import UnsentMailContainer from '../../containers/unsentMail/unsentMailContainer';

export default function UnsentMail(props) {
  const { open = true, onClose = false } = props;
  if (open) return <UnsentMailContainer open={open} onClose={onClose} />;
  return <div />;
}
